import React, { useState } from "react";

import { ProductTileModel } from "@api/mappers/products.mapper";

import { formatPrice } from "@utils/productPrice";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { Button } from "@components/General/Button/button.component";

import "./accessories.scss";

type AccessoriesProps = {
    accessories: Array<ProductTileModel>;
    onAdd: (sku: string, product: ProductTileModel) => Promise<void>;
};

const DEFAULT_LIMIT = 3;
const MAX_ITEMS = 9;

const Accessories = ({ accessories, onAdd }: AccessoriesProps) => {
    const { t } = useGranite();
    const [limit, setLimit] = useState(DEFAULT_LIMIT);
    const [isAdding, setIsAdding] = useState(false);

    const onAddAccessory = (product: ProductTileModel) => {
        setIsAdding(true);
        onAdd(product.sku, product).finally(() => setIsAdding(false));
    };

    return (
        <>
            <p>{t("general.cartItem.accessory.title")}</p>
            {accessories.slice(0, limit).map(acc => {
                return (
                    <div className="pb-2" key={acc.sku}>
                        <Button
                            size="sm"
                            type="button"
                            onClick={() => onAddAccessory(acc)}
                            loading={isAdding}
                            className="d-inline-block p-1 btn-accessories__add"
                        >
                            <i className="las la-plus"></i>
                        </Button>
                        <span className="pl-2">
                            {acc.title} | {formatPrice(acc.salesPrice)}
                        </span>
                    </div>
                );
            })}
            {Math.min(accessories.length, MAX_ITEMS) > limit && (
                <Button
                    type="button"
                    color="link"
                    onClick={() => setLimit(state => state + DEFAULT_LIMIT)}
                >
                    {t("general.cartItem.accessory.showMore")}
                </Button>
            )}
            {limit !== DEFAULT_LIMIT && (
                <Button
                    type="button"
                    color="link"
                    onClick={() => setLimit(state => state - DEFAULT_LIMIT)}
                >
                    {t("general.cartItem.accessory.showLess")}
                </Button>
            )}
        </>
    );
};

export { Accessories };
